import { BaseMarkerStateManager } from '../base/baseMarkerStateManager'
import { BezierLineMarker } from './bezierLineMarker'
import { MarkerModes, type AnchorPoints, type BezierLineMarkerState, type ControlPoints, type Point } from '../../types'
import { BezierAdjustmentHandle } from './bezierAdjustmentHandle'

export class BezierLineMarkerStateManager extends BaseMarkerStateManager<
  BezierLineMarker,
  BezierLineMarkerState,
  BezierAdjustmentHandle
> {
  anchorPoints: AnchorPoints = []
  controlPoints: ControlPoints = []
  handles: Array<BezierAdjustmentHandle> = []

  constructor(marker: BezierLineMarker) {
    super(marker)
    this.marker = marker
  }

  appendVertex(point: Point) {
    const isFirstAnchor = this.handles.length === 0

    //First anchor is drawn as a regular vertex
    //Though a control point is rendered at
    //first vertex of the bezier curve - it is
    //actually the "start" control point of the next
    //vertex.

    //This applies to preceding vertexes as well.
    //Of the two control points that are rendered
    //attached to the vertex, one is is the current
    //bezier vertex' "end" control point and the other
    //corresponds with the next vertex' "start" control
    //point.

    //This is done as it's more intuitive ux.
    //and partly due to how the bezierVertex is
    //implemented in p5. With the first point of
    //the shape having to be a regular vertex
    //rather than a bezierVertex
    //also
    //This implementation follows other
    //common design tools
    //(i.e. ps, figma)

    //If replacing with another graphics library
    //or rolling a custom library, the
    //bezierimplementation, for said library,
    //should be double checked

    let newHandle

    //TODO Remove logic that adds new handle - as markerhanldes should populate handles based on anchorPoints

    if (isFirstAnchor) {
      newHandle = new BezierAdjustmentHandle(
        this.marker.p,
        point,
        { start: null, end: null },
        this.handleRadius,
        this.handleStrokeWeight
      )
    } else {
      const latestHandle = this.handles[this.handles.length - 1]
      const newControlPoint = {
        start: Object.assign({}, latestHandle.position),
        end: Object.assign({}, point),
      }
      const newHandleControlPointPositions = {
        start: newControlPoint.end,
        end: null,
      }
      newHandle = new BezierAdjustmentHandle(
        this.marker.p,
        point,
        newHandleControlPointPositions,
        this.handleRadius,
        this.handleStrokeWeight
      )
      latestHandle.controlPointPositions = {
        ...latestHandle.controlPointPositions,
        end: newControlPoint.start,
      }
      this.controlPoints.push(newControlPoint)
    }

    this.handles.push(newHandle)
    this.anchorPoints.push(point)
  }

  moveMarker(deltaX: number, deltaY: number): void {
    this.anchorPoints.forEach((anchor) => {
      anchor.x += deltaX
      anchor.y += deltaY
    })
    this.controlPoints.forEach((point) => {
      if (point.start) {
        point.start.x += deltaX
        point.start.y += deltaY
      }
      if (point.end) {
        point.end.x += deltaX
        point.end.y += deltaY
      }
    })
  }

  public restore(state: BezierLineMarkerState): void {
    super.restore(state)
    //TODO Method for restoring control point positions needed
    //Need to translate from array of points to a bezier curve with control points
    this.anchorPoints = state.anchorPoints
  }

  public export(): BezierLineMarkerState {
    return Object.assign(
      {
        anchorPoints: this.anchorPoints,
        controlPoints: this.controlPoints,
      },
      super.export()
    )
  }
}
